import React from 'react';
import { ExternalLink, ArrowRight } from 'lucide-react';

const PrysmeGroup = () => {
  return (
    <section id="prysme" className="py-16 bg-gradient-to-br from-gray-50 to-slate-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Prysme le groupe
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Découvrez le groupe Prysme et son écosystème d'expertise au service de l'excellence.
          </p>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-100">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center">
              {/* Text Content */}
              <div>
                <div className="mb-6">
                <p className="text-gray-700 leading-relaxed mb-6">
                  Le Groupe Prysme incarne l'art de vivre professionnel en plaçant l'Humain, la convivialité et l'audace au cœur de son action. À travers ses cinq marques fortes, il propose des services complémentaires et pleins de sens.
                </p>
              </div>

                {/* CTA Button */}
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="https://prysme.eu"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center justify-center px-6 py-3 bg-[#4b9fcc] text-white rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 hover:bg-[#e71f74] hover:shadow-lg"
                  >
                    <span className="mr-2">Visiter prysme.eu</span>
                    <ExternalLink className="w-4 h-4 group-hover:rotate-12 transition-transform duration-300" />
                  </a>
                </div>
              </div>

              {/* Visual Element */}
              <div className="lg:order-first">
                <div className="relative">
                  <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                    <div className="text-center">
                      <div className="mb-6">
                        <img 
                          src="https://customer-assets.emergentagent.com/job_sisens-cuisine/artifacts/ux6lx5cu_logo-prysme-couleur.png" 
                          alt="Groupe Prysme Logo" 
                          className="h-16 w-auto mx-auto transition-transform duration-300 hover:scale-110"
                        />
                      </div>
                      
                      <h3 className="text-xl font-bold text-gray-900 mb-3">
                        Groupe Prysme
                      </h3>
                      
                      <p className="text-gray-600 mb-4 text-sm">
                        L'art de vivre professionnel à travers cinq marques complémentaires.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrysmeGroup;